import { api, ApiError } from "@/api/api";
import { CreateMasterCombination, MasterCombination } from "@/api/master-combinations-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useCreateMasterCombination() {
  const queryClient = useQueryClient();
  return useMutation<MasterCombination, ApiError, CreateMasterCombination>({
    mutationKey: ["POST", "master-combinations"],
    mutationFn: api.masterCombinations.post,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GET", "master-combinations"] });
    },
  });
}
